import { useSubscribeToPrivateWebsocketEvent } from '~/core/shared/contexts/websockets';
import { User } from '../../../../types';
import { buildUserChannelName } from '../../logic/buildUserChannelName';
import { UserPrivateWebsocketEvent } from '../../types/UserPrivateWebsocketEvent';
import { UserPrivateWebsocketEventPayload } from '../../types/UserPrivateWebsocketEventPayload';

export const useSubscribeToUserMessage = (
  userId: User['id'],
  onMessage: (
    payload: UserPrivateWebsocketEventPayload[UserPrivateWebsocketEvent.Message],
  ) => void,
): void => {
  useSubscribeToPrivateWebsocketEvent(
    buildUserChannelName(userId),
    UserPrivateWebsocketEvent.Message,
    onMessage,
  );
};
